import { ValidationOutcomes, ValidationResult } from '.';
import { isObjectEmpty } from '../utils/aem-utils/utils';

const ValidateFormContainerComponentProps = (props: any): ValidationResult => {
  const vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
  };

  if (isObjectEmpty(props)) {
    vr.messages.push('Form container is empty');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  if (
    Object.prototype.hasOwnProperty.call(props, 'items') &&
    (props.items === null ||
      (!Array.isArray(props.items) && typeof props.items !== 'object'))
  ) {
    vr.messages.push('Form container items must be an array or object');
    vr.result = ValidationOutcomes.FAILURE;
    return vr;
  }

  vr.componentProps = props;
  vr.result = ValidationOutcomes.SUCCESS;
  return vr;
};

export default ValidateFormContainerComponentProps;
